import { render, staticRenderFns } from "./CompanyBusinessRelations.vue?vue&type=template&id=6118c309&scoped=true"
import script from "./CompanyBusinessRelations.vue?vue&type=script&lang=js"
export * from "./CompanyBusinessRelations.vue?vue&type=script&lang=js"
import style0 from "./CompanyBusinessRelations.vue?vue&type=style&index=0&id=6118c309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6118c309",
  null
  
)

export default component.exports